import PersonalDetailsSimpleView from './PersonalDetailsSimpleView'

export default PersonalDetailsSimpleView
